<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Detail Perusahaan</strong>
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Kategori"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  disabled
                  placeholder="Kategori"
                  v-model.trim="registrationDetail.category"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                :label="objectLabel.company"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                :placeholder="objectLabel.company"
                v-model.trim="registrationDetail.company_name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="!isCorporation">
            <CCol :col="8">
              <CInput
                  label="Email"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  disabled
                  placeholder="Email"
                  v-model.trim="registrationDetail.email"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                :label="objectLabel.name"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                :placeholder="objectLabel.name"
                v-model.trim="registrationDetail.pic_name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                :label="objectLabel.telphone"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                :placeholder="objectLabel.telphone"
                v-model.trim="registrationDetail.phone_number"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="!isCorporation">
            <CCol :col="8">
              <CInput
                  label="Pesan/Pertanyaan"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  disabled
                  placeholder="Pesan/Pertanyaan"
                  v-model.trim="registrationDetail.question"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="isCorporation">
            <CCol :col="8">
              <CInput
                label="Posisi PIC"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                placeholder="Posisi PIC"
                v-model.trim="registrationDetail.job_position"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="isCorporation">
            <CCol :col="8">
              <CInput
                label="Kategori Perusahaan"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                placeholder="Kategori Perusahaan"
                v-model.trim="registrationDetail.company_category"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="isCorporation">
            <CCol :col="8">
              <CInput
                label="NPWP"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                v-model.trim="registrationDetail.npwp"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="isCorporation">
            <CCol :col="8">
              <CInput
                label="Alamat Penagihan"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                v-model.trim="registrationDetail.billing_address"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Status"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                placeholder="Status"
                v-model.trim="registrationDetail.flag"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Catatan"
                class="mb-0"
                type="text"
                required
                horizontal
                disabled
                placeholder="Catatan"
                v-model.trim="registrationDetail.reason"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <!-- <CButton color="success" class="float-right" @click="updateBusinessInquiry">Save</CButton> -->
            </CCol>
          </CRow>
        </CCardFooter>
        <CCardBody>
          <div class="judul">
            <strong>
              <h3>Action Log</h3>
            </strong>
          </div>
          {{ registrationDetail.Histories }}
          <CDataTable
            hover
            :items="registrationDetail.histories"
            :fields="fields"
          ></CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken";
import moment from "moment";
export default {
  name: "ListingDetail",
  data() {
    return {
      registrationDetail: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      options: ["FOLLOW UP", "ACCEPT", "REJECT", "HOLD"],
      fields: [
        { key: "flag", label: "Action" },
        { key: "reason", label: "Information" },
        { key: "created_by", label: "Created By" },
        { key: "created_at", label: "Created On" },
      ],
      objectLabel: {
        name: "Nama PIC",
        telphone: "No HP PIC",
        company: "Nama Perusahaan",
      },
      isCorporation: false,
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  methods: {
    getDataByID() {
      let busineesInquiryID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/business/${busineesInquiryID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.registrationDetail = response.data;
          this.isCorporation = response.data.category.toUpperCase() === 'CORPORATION'
          if (!this.isCorporation) {
            this.objectLabel.name = "Nama Lengkap"
            this.objectLabel.telphone =  "No. Handphone"
            this.objectLabel.company = "Nama Usaha/Merek"
          }

          this.registrationDetail.histories.forEach((element) => {
            element.created_at = moment(String(element.created_at)).format(
              "MM/DD/YYYY hh:mm A"
            );
          });
        })
        .catch((e) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: e.response.data.message.id,
          });
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "SALES" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.$router.back()
    },
    handleStatusFlag(event) {
      this.registrationDetail.flag = event.target.value;
    },
    handleReason(event) {
      this.registrationDetail.reason = event;
    },
    updateBusinessInquiry() {
      let busineesInquiryID = this.$route.params.id;
      axios
        .put(
          `${this.domain}/v1/business/${busineesInquiryID}`,
          this.registrationDetail,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Data Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/business_inquiry` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
          console.log(err);
        });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
  },
};
</script>

<style scoped>
@import "./BusinessInquiry.css";
</style>
